import {
  Location,
  NavigateFunction,
  NavigateOptions,
  To,
} from 'react-router-dom'

let navigateFunction: NavigateFunction | undefined
let locationObject: Location | undefined

export const setNavigate = (navFn: NavigateFunction) => {
  navigateFunction = navFn
}

export const setLocation = (location: Location) => {
  locationObject = location
}

export const navigate: (
  to: To,
  options?: NavigateOptions | undefined,
) => void = (to, options) => {
  if (!navigateFunction) console.error('Navigate function not set yet')

  navigateFunction?.(to, options)
}

export const location = () => (locationObject || {}) as Location
